import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { getApiUrl } from '../config/api';

const SignLeasePage = () => {
  const { leaseId } = useParams();
  const [signingUrl, setSigningUrl] = useState(null);

  useEffect(() => {
    fetch(getApiUrl(`/api/leases/${leaseId}/signing-url`))
      .then(res => res.json())
      .then(data => setSigningUrl(data.signing_url));
  }, [leaseId]);

  return (
    <Layout pageTitle="Sign Lease">
      <section className="dashboard-card summary-card">
        <h2>Lease Signing</h2>
        {!signingUrl ? (
          <p>Loading signing experience...</p>
        ) : (
          <iframe
            src={signingUrl}
            title="Lease Signing"
            width="100%"
            height="800px"
            className="rounded-lg border shadow"
            frameBorder="0"
          ></iframe>
        )}
      </section>
    </Layout>
  );
};

export default SignLeasePage;
